export default __webpack_public_path__ + "pgnv-assets/fbebf132b1a47eac2bb2227bebe88758.png";